<template>
    <div class="hand-up-box">
        <div class="title-bar">
            <led-timer v-if="timerRequired" :time-in-seconds="timeInSeconds" type="countup"></led-timer>
            <p>举手</p>
        </div>
        <div ref="handUpMember" class="hand-up-content">
            <div v-if="hintData === 'start'" class="hint-box">
                <div class="hint-content">
                    <img :src="handUpIcon" alt="">
                    <p>{{ hintContent }}</p>
                </div>
            </div>

            <div v-if="hintData === 'startUp'" class="start-up-box">
                <span></span>
                <div class="start-tips">
                    <div class="tips-surplus">当前举手同学</div>
                    <div class="tips-members" v-text="handUpMembers.length ? handUpMembers.length + '位' : '暂无' "></div>
                </div>

                <div ref="startMembers" class="start-members">
                    <div ref="membersTitle" class="members-title">举手已开始，请大家在手机上点击【举手】参与</div>
                    <div ref="membersResult" class="members-result clearfix">
                        <div v-for="item in handUpMembers" :id="item.id" :key="item.id" class="members-user">
                            <div>
                                <img :src="item.avatarUrl == null ? avatarUrl : item.avatarUrl" alt="" class="user-img" :class="{'has-chosen' : item.isChosen}">
                                <img v-if="item.isChosen" src="../assets/image/has_chosen.png" class="has-choose">
                            </div>
                            <p>{{ item.fullName }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="hintData == 'setMembers'" class="hand-up-menber">
                <p class="hand-up-menber-title">请开始你的表演，并等待老师评分</p>
                <div class="hand-up-menber-result">
                    <div v-for="(item,index) in handUpMembers" :id="'result-box-' + item.id" :key="'handup-' + index.id" class="hand-up-menber-result-user">
                        <div class="user-avatar">
                            <img :src="item.avatarUrl == null ? avatarUrl : item.avatarUrl" alt="">
                            <div v-show="item.score !== undefined" :class=" item.score < 0 ? 'negative' : '' " class="score">{{ item.score }}</div>
                        </div>
                        <p class="hand-up-name">{{ item.fullName }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import ledTimer from './ledTimer.vue';
import handUpIcon from '@/assets/image/hand_up_icon.png';
import avatarUrl from '@/assets/image/user-avatarUrl.jpg';
import Wings from '../assets/scripts/wings.js';
import Vue from 'vue';

export default {
    components: {
        ledTimer
    },

    props: {
        isLock: {
            type: Boolean,
            default: false
        },
        currentShow: {
            type: String,
            default: ''
        }
    },
    
    data: function() {
        return {
            supportedEventNames: [
                'crp.handUp.start',
                'crp.handUp.startUp',
                'crp.handUp.attend',
                'crp.handUp.chooseMember',
                'crp.handUp.cancelChooseMember',
                'crp.handUp.setMembers',
                'crp.handUp.removeMember',
                'crp.handUp.setScore',
                'crp.handUp.end',
                'common.moveJoystick'],
            avatarUrl: avatarUrl,
            handUpIcon: handUpIcon,
            hintContent: '即将开始举手活动，请大家做好准备',
            hintData: 'start',
            timerRequired: false,
            clazzCourseId: null,
            serverTimestamp: null,
            members: [],
            handUpMembers: [],
            wings: null,
        };
    },

    computed:{
        timeInSeconds: function() {
            if ( ! this.timerRequired) return 0;
            let d = new Date(this.serverTimestamp);
            d = Math.floor(d.getTime() / 1000);
            return (d - this.serverTimestamp);
        }
    },

    watch: {
        currentShow: function (newVal, oldVal) {
            // the stage is hiding me
            if (newVal !== this.componentId && oldVal === this.componentId) {
                this.serverTimestamp = null;
                this.timerRequired = false;
                this.members = [];
                this.handUpMembers = [];
                this.wings.hideAnimation();
                if (this.$refs.membersResult) this.$refs.membersResult.scrollTop = 0;
                if (this.$refs.handupMember) this.$refs.handUpMember.scrollTop = 0;
            }
        }
    },

    created: function() {
        this.wings = new Wings();
    },

    mounted: function() {
        this.componentId = this.$attrs.id;
        window.addEventListener('message', this.windowMessageHandler);
    },

    destroyed: function() {
        window.removeEventListener('message', this.windowMessageHandler);
        this.componentId = null;
    },

    methods: {
        windowMessageHandler: function(e) {
            const msg = e.data;
            if ( ! msg) return;
            if ( ! msg.eventName || this.supportedEventNames.indexOf(msg.eventName) === -1) return;

            const msgData = msg.data;
            // console.log(msgData);
            switch (msg.eventName) {
                case 'crp.handUp.start':
                    this.crpHandUpStart(msgData);
                    break;
                case 'crp.handUp.startUp':
                    if (msgData.clazzCourseId !== this.clazzCourseId) return;
                    this.crpHandUpStartUp();
                    break;
                case 'crp.handUp.attend':
                    if (msgData.clazzCourseId !== this.clazzCourseId) return;
                    this.crpHandUpAttend(msgData);
                    break;
                case 'crp.handUp.chooseMember':
                    if (msgData.clazzCourseId !== this.clazzCourseId) return;
                    this.crpHandUpChooseMember(msgData);
                    break;
                case 'crp.handUp.cancelChooseMember':
                    if (msgData.clazzCourseId !== this.clazzCourseId) return;
                    this.crpHandUpCancelChooseMember(msgData);
                    break;
                case 'crp.handUp.setMembers':
                    if (msgData.clazzCourseId !== this.clazzCourseId) return;
                    this.crpHandUpSetMembers(msgData);
                    break;
                case 'crp.handUp.removeMember':
                    if (msgData.clazzCourseId !== this.clazzCourseId) return;
                    this.crpHandUpRemoveMember(msgData);
                    break;
                case 'crp.handUp.setScore':
                    if (msgData.clazzCourseId !== this.clazzCourseId) return;
                    this.crpHandUpSetScore(msgData);
                    break;
                case 'common.moveJoystick':
                    if (this.componentId) this.moveJoystick(msgData);
                    break;
                case 'crp.handUp.end':
                    this.crpHandUpEnd();
                    break;
                default:
                    // statements_def
                    break;
            }
        },

        crpHandUpStart: function(msgData) {
            this.hintData = 'start';
            this.clazzCourseId = msgData.clazzCourseId;
            this.serverTimestamp = msgData.serverTimestamp;
            this.members = msgData.members;
        },

        crpHandUpStartUp: function() {
            this.hintData = 'startUp';
            this.timerRequired = 'Y';
            // 滚动条问题
            Vue.nextTick(() => {
                let smH = this.$refs.startMembers.getBoundingClientRect().height;
                let mtH = this.$refs.membersTitle.getBoundingClientRect().height;
                this.$refs.membersResult.style.height = smH - mtH + 'px';
                console.log(smH,mtH);
                console.log(this.$refs.membersResult);
            });
        },

        crpHandUpAttend: function(msgData) {
            let index = null;
            if (msgData.memberId) {
                index = this.members.findIndex(m => m.id === msgData.memberId);
            } else if (msgData.id) {
                index = this.handUpMembers.findIndex(m => m.id === msgData.id);
            } else {
                index = this.members.findIndex(m => m.id === msgData);
            }

            this.members[index].isHandUp = true;
            this.members[index].isChosen = false;
            if (msgData.score !== undefined) {
                let sameScore = false;
                if (this.handUpMembers[index].score === msgData.score) sameScore = true;

                this.handUpMembers[index].score = msgData.score;
                this.$set(this.handUpMembers,index,this.handUpMembers[index]);

                if (sameScore) return;
                const avatar = document.querySelector('#result-box-' + this.handUpMembers[index].id).querySelector('.user-avatar > img');
                this.wings.pushAnimation(avatar, this.handUpMembers[index].fullName, this.handUpMembers[index].score);
                return;
            };
            this.handUpMembers.push(this.members[index]);
        },

        crpHandUpChooseMember: function(msgData) {
            let choose = this.handUpMembers.findIndex(ele => ele.id === msgData.memberId);
            this.handUpMembers[choose].isChosen = true;
            this.$set(this.handUpMembers,choose,this.handUpMembers[choose]);

            if (!this.handUpMembers[choose].isChosen) return;
            this.handleChosenMembers(this.handUpMembers[choose].id);
        },

        crpHandUpCancelChooseMember: function(msgData) {
            let choose = this.handUpMembers.findIndex(ele => ele.id === msgData.memberId);
            this.handUpMembers[choose].isChosen = false;
            this.$set(this.handUpMembers,choose,this.handUpMembers[choose]);
        },

        handleChosenMembers: function(member) {
            let startMembers = this.$refs.startMembers;
            let membersResult = this.$refs.membersResult;
            let chooseMember = document.getElementById(member);
            
            // 可视区的可用高度
            let viewT = startMembers.getBoundingClientRect().height;
            // 可视区的位置
            let viewH = startMembers.getBoundingClientRect().top;
            // 元素的位置
            let chooseH = chooseMember.getBoundingClientRect().top;

            //元素在父元素的位置
            let cTov = chooseH - viewH;
            // console.log(cTov,viewT);

            // 元素不处在可视区的情况
            if (cTov >= viewT || cTov <= 0) {
                membersResult.scrollTop = cTov - 90;
            };
        },

        crpHandUpSetMembers: function(msgData) {
            this.hintData = 'setMembers';
            this.serverTimestamp = null;
            this.timerRequired = false;
            this.handUpMembers = [];
            msgData.chosenMemberIds.forEach(c => {
                this.crpHandUpAttend(c);
            });
        },

        crpHandUpRemoveMember: function(msgData) {
            let remove = this.handUpMembers.findIndex(ele => ele.id === msgData.removeMemberId);
            this.handUpMembers.splice(remove,1);
        },

        crpHandUpSetScore: function(msgData) {
            msgData.chosenMembers.forEach(m => {
                this.crpHandUpAttend(m);
            });
        },

        moveJoystick: function(msgData) {
            let box = null;
            let direction = msgData.direction;
            let membersResult = this.$refs.membersResult;
            let handUpMember = this.$refs.handUpMember;

            if (this.hintData === 'startUp') {
                box = membersResult;
                this.boxOfElement(direction,box);
            } else if (this.hintData === 'setMembers') {
                box = handUpMember;
                this.boxOfElement(direction,box);
            } else {
                return;
            }



        },

        boxOfElement: function(direction,box) {
            if (direction === 'LEFT') {
                return;
            } else if (direction === 'RIGHT') {
                return;
            } else if (direction === 'UP') {
                box.scrollTop -= 40;
            } else if (direction === 'DOWN') {
                box.scrollTop += 40;
            } else {
                return;
            }
        },

        crpHandUpEnd: function() {
            this.wings.hideAnimation();
        },

    }
};
</script>

<style scoped>
    .hand-up-box {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }

    .title-bar {
        width: 100%;
        display: flex;
        height: 80px;
        background-color: #191919;
        justify-content: space-between;
        align-items: center;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 99;
        padding: 0 40px;
        box-sizing: border-box;
    }

    .title-bar p {
        font-size: 24px;
        color: #ffffff;
        text-align: center;
        width:600px;
        flex: 2;
    }

    .hand-up-content {
        width: 100%;
        height: 100%;
        padding-top: 80px;
        box-sizing: border-box;
        display: flex;
        flex: 2;
        overflow-y: auto;
    }

    .hint-box {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 1;
    }
    
    .hint-content {
        display: flex;
        align-items: center;
        font-size: 24px;
        color: #e8e8e8;
        align-items: center;
        flex-direction: column;
        margin-top: -80px;
    }

    .hint-content img {
        width: 200px;
        height: 200px;
    }

    .start-up-box {
        padding: 40px 40px 60px 40px;
        display: flex;
        flex: 2;
        /* overflow: hidden; */
    }

    .start-tips {
        width: 300px;
        height: 300px;
        border-radius: 8px;
        background: #ffb22e;
        overflow: hidden;
        margin-right: 40px;
    }

    .tips-surplus {
        width: 100%;
        height: 80px;
        background: #ffffff;
        color: #ffb22e;
        font-size: 30px;
        line-height: 80px;
    }

    .tips-members {
        width: 100%;
        height: 220px;
        background-image: url('../assets/image/tips_members.png');
        background-repeat: no-repeat;
        background-position: 50% 50%;
        background-size: 132px 156px;
        font-size: 60px;
        color: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .start-members {
        width: 100%;
        background: #444444;
        flex: 1;
        border-radius: 8px 8px 0px 0px;
        position: relative;
    }

    .members-title {
        width: 100%;
        height: 60px;
        border-radius: 8px 8px 0px 0px;
        background: #191919;
        font-size: 24px;
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 9;
    }

    .members-result {
        margin-top: 60px;
        padding: 40px 0px 0px 0px;
        flex-wrap: wrap;
        overflow-y: auto;
        box-sizing: border-box;
    }

    .members-result > div {
        width: 200px;
        margin-bottom: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        float: left;
    }

    .members-user > div {
        width: 120px;
        height: 120px;
        position: relative;
    }

    .user-img {
        width: 120px;
        height: 120px;
        border-radius: 50%;
        border: 6px solid #ffffff;
        box-sizing: border-box;
    }

    .has-chosen{
        border-color: #ffb22e;
    }

    .has-choose{
        width: 40px;
        height: 40px;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%,20px);
    }

    .members-user > p {
        font-size: 24px;
        color: #FFFFFF;
        margin-top: 20px;
        max-width: 150px;
        overflow:hidden; 
        text-overflow:ellipsis;
        display:-webkit-box; 
        -webkit-box-orient:vertical;
        -webkit-line-clamp:1; 
    }

    .score {
        width: 200px;
        padding: 50px 0 20px 0;
        background-image: url("../assets/image/score.png");
        background-repeat: no-repeat;
        background-size: 200px 100px;
        position: absolute;
        bottom: 0;
        left: 0;
        text-align: center;
        font-size: 30px;
        line-height: 30px;
        color: #ffffff;
    }

    .negative {
        background-image: url("../assets/image/negative.png");
        background-size: 200px 100px;
    }

    .hand-up-menber {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        /* padding: 0 60px; */
        box-sizing: border-box;
    }

    .hand-up-menber-result {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
    }

    .hand-up-menber-result > div {
        width: 240px;
        margin: 30px 0;
        display: flex;
        align-items: center;
        flex-direction: column;
    }

    .user-avatar {
        width: 200px;
        height: 200px;
        box-sizing: border-box;
        border-radius: 50%;
        overflow: hidden;
        position: relative;
    }

    .user-avatar img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        box-sizing: border-box;
        border: 6px solid #ffffff;
    }

    .score {
        width: 200px;
        padding: 50px 0 20px 0;
        background-image: url("../assets/image/score.png");
        background-repeat: no-repeat;
        background-size: 200px 100px;
        position: absolute;
        bottom: 0;
        left: 0;
        text-align: center;
        font-size: 30px;
        line-height: 30px;
        color: #ffffff;
    }

    .negative {
        background-image: url("../assets/image/negative.png");
        background-size: 200px 100px;
    }

    .hand-up-menber-result-user p {
        max-width: 200px;
        font-size: 24px;
        color: #CCCCCC;
        text-align: center;
        margin-top: 20px;
        overflow: hidden; 
        text-overflow: ellipsis;
        display: -webkit-box; 
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1; 
    }

    .hand-up-menber-title {
        font-size: 24px;
        color: #e8e8e8;
        padding: 60px 0 30px 0;
    }
</style>
